import React, { useCallback, useState } from 'react'
import { Alert } from 'react-bootstrap'
import Progress from '../Form/Progress'
import { useAssetDataState } from '../../../stores/AssetDataProvider'
import { ButtonWithLoadingState } from '../../Buttons'
import { useAssetsState } from '../../../stores/AssetsProvider'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'


const StyledContainer = styled.div`
  @media screen and (min-width: 1081px) {
    position: sticky;
    top: 50px;
  }
`

const Sidebar = () => {
  const {
    submitAddAsset,
    errorsOccurredOnSubmit,
    setSuccessSubmit,
    successSubmit
  } = useAssetDataState()
  const { setFilterAsset } = useAssetsState()
  const [isSaving, setIsSaving] = useState(false)
  const navigate = useNavigate();

  const handleSubmitClick = useCallback(async e => {
    e.preventDefault()
    e.stopPropagation()
    setSuccessSubmit(false)
    setIsSaving(true)
  
      const createdAssetInfo = await submitAddAsset()
      if (createdAssetInfo) {
        const { assetNo } = createdAssetInfo
        setFilterAsset(assetNo)
        setTimeout(() => {
          navigate("/assets")
        }, 1500)
      }

    setIsSaving(false)
  }, [setSuccessSubmit, submitAddAsset, setFilterAsset, navigate])

  const { t } = useTranslation()

  return (
    <StyledContainer>
      <header>
        <div className="h2">{t('assetOverlayProgress:header')}</div>
      </header>
      <div className="content">
        <ButtonWithLoadingState
          className="submit-btn mb-3"
          isLoading={isSaving}
          onClick={handleSubmitClick}
          disabled={isSaving || successSubmit}
          buttonText={t('assetOverlayProgress:save')}
          loadingText={t('assetOverlayProgress:save')}
        />
        {!!errorsOccurredOnSubmit && (
          <Alert variant="danger">
            {t('assetOverlayProgress:danger')}
          </Alert>
        )}
        {!!successSubmit && (
          <Alert variant="success">
            {t('assetOverlayProgress:success')}

          </Alert>
        )}
        <Progress />
      </div>

    </StyledContainer>
  )
}

export default Sidebar
